<template>
  <div class="table-container">
    <a-card title="待生成报告列表">
      <a-button slot="extra" type="primary" style="height:29px" @click="add">
        新增
      </a-button>

      <a-table :columns="columns" :data-source="data" bordered>
        <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`按 ${column.title} 搜索`" :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            重置
          </a-button>
        </div>
        <a-icon slot="filterIcon" slot-scope="filtered" type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }" />

        <template slot="customRender" slot-scope="text, record, index, column">
          <span v-if="searchText && searchedColumn === column.dataIndex">
            <template v-for="(fragment, i) in text
        .toString()
        .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i" class="highlight">{{ fragment
                }}</mark>
              <template v-else>{{ fragment }}</template>
            </template>
          </span>
          <template v-else>
            {{ text }}
          </template>
        </template>

        <div v-for="col in ['taskId', 'headline', 'date', 'position', 'fix', 'detector', 'summary', 'tag']" :slot="col"
          slot-scope="text, record " :key="col">

          <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
            @change="e => handleChange(e.target.value, record.key, col)" />
          <template v-else>
            {{ text }}
          </template>
        </div>
        <span slot="tag" slot-scope="tag">
          <a-tag :color="tag === '严重' ? 'volcano' : tag === '中等' ? 'geekblue' : 'green'" @click="tagClick(tag)">
            {{ tag }}
          </a-tag>
        </span>
        <template slot="operation" slot-scope="text, record ">
          <div class="editable-row-operations">
            <span v-if="record.editable">
              <a @click="() => save(record.key)" style="color: green;">保存</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认要取消吗" @confirm="() => cancel(record.key)">
                <a>取消</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <a :disabled="editingKey !== ''" @click="() => edit(record.key)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="将会永久删除（真的很久！）" @confirm="() => dele(record.key)">
                <a style="color: red;">删除</a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a @click="() => gene(record.key)">生成</a>
            </span>
          </div>
        </template>
      </a-table>
    </a-card>
  </div>
</template>


<script>
const TEST_URL = "http://127.0.0.1:8086/chart/"
const TRUE_URL = process.env.VUE_APP_URL_REPORT_SERVICE

const columns = [
  {
    title: '任务编号',
    dataIndex: 'taskId',
    width: '8%',
    scopedSlots: { customRender: 'taskId' },
    sorter: (a, b) => parseInt(a.taskId, 10) - parseInt(b.taskId, 10),
  },
  {
    title: '标题',
    dataIndex: 'headline',
    width: '15%',
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'headline',
    },
    onFilter: (value, record) =>
      record.headline
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus();
        });
      }
    },
  },
  {
    title: '日期',
    dataIndex: 'date',
    width: '10%',
    scopedSlots: { customRender: 'date' },
    sorter: (a, b) => new Date(a.date.replace(/\./g, '-')) - new Date(b.date.replace(/\./g, '-')),
  },
  {
    title: '坐标',
    dataIndex: 'position',
    width: '15%',
    scopedSlots: { customRender: 'position' },
  },
  {
    title: '养护人员',
    dataIndex: 'fix',
    width: '10%',
    scopedSlots: {
      customRender: 'fix',
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.fix
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus();
        });
      }
    },
  },
  {
    title: '检测人员',
    dataIndex: 'detector',
    width: '10%',
    scopedSlots: {
      customRender: 'detector',
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.detector
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus();
        });
      }
    },
  },
  {
    title: '摘要',
    dataIndex: 'summary',
    width: '55%',
    scopedSlots: {
      customRender: 'summary',
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.summary
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus();
        });
      }
    },
  },
  {
    title: '重要程度',
    key: 'tag',
    dataIndex: 'tag',
    align: 'center',
    scopedSlots: { customRender: 'tag' },
    width: '50%',
    filters: [{
      text: '普通',
      value: '普通',
    }, {
      text: '中等',
      value: '中等',

    }, {
      text: '严重',
      value: '严重',
    }],
    filterMultiple: true,
    onFilter: (value, record) => record.tag == value,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 200,
    align: 'center',
    fixed: 'right',
  },
];

const data = [];
/*
for (let i = 1; i <= 20; i++) {
  let ttag = ''; // 声明 ttag 变量，用来存储标签信息
  if ((i + 1) % 3 === 0) {
    ttag = '中等'; // 满足 (i + 1) 是 3 的倍数时，设置为 '中等'
  } else if (i % 3 === 0) {
    ttag = '严重'; // 满足 i 是 3 的倍数时，设置为 '严重'
  } else {
    ttag = '普通'; // 否则设置为 '普通'
  }
  data.push({
    key: i.toString(),
    id: `${i}`,
    headline: `Report ${i}`,
    date: `2024.3.${i}`,
    position: `东经${i}北纬${i}`,
    fix: i.toString(),
    detector: (i + 2).toString(),
    summary: `东经${i}北纬${i} 出现了${ttag}裂缝😱`,
    tag: ttag // 使用 ttag 变量保存标签信息
  });
}
*/
import axios from 'axios';

export default {
  data() {
    this.cacheData = data.map(item => ({ ...item }));
    return {
      data,
      columns,
      editingKey: '',
      searchText: '',
      searchInput: null,
      searchedColumn: '',
    };
  },
  methods: {
    async fetchData() {
      try {
        const response = await axios.get(TRUE_URL+'task/');
        
        const jsonResponse = response.data;
        console.log("chart/task/get_task:"+jsonResponse);

        this.data = jsonResponse.map((item, index) => ({
          key: (index + 1).toString(),
          taskId: item.taskId.toString(),
          headline: item.headline,
          // 这里还需要修复一下
          // date: item.date.split('T')[0], // 去掉时间部分
          position: item.position,
          fix: item.fix,
          detector: item.detector,
          summary: item.summary,
          tag: item.tag
        }));
      } catch (error) {
        console.error('Fetch error: ', error);
      }
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      if (target) {
        this.$set(target, column, value); // 使用 $set 方法更新属性值
        this.data = newData;
      }
    },
    edit(key) {
      this.tempData = JSON.parse(JSON.stringify(this.data));
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      this.editingKey = key;
      if (target) {
        this.$set(target, 'editable', true); // 使用 $set 方法设置 editable 属性为 true
        this.data = newData;
      }
    },
    async save(key) {
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      if (target) {
        this.$delete(target, 'editable'); // 使用 $delete 方法删除 editable 属性
        this.data = newData;

        try {
          // 向后端发送 PUT 请求更新数据
          await axios.put(`${ TRUE_URL }task/${target.id}`, target);

          // 显示保存成功的提示
          const notificationKey = `save-notification-${key}`;
          this.$notification.open({
            message: '已保存！',
            description: `已保存对${target.headline}的修改！`,
            icon: <a-icon type="alert" style="color: green" />,
            key: notificationKey,
            onClick: () => {
              console.log('Notification Clicked!');
            },
          });
        } catch (error) {
          console.error('Save error: ', error);
          this.$notification.error({
            message: '保存失败！',
            description: `保存对${target.headline}的修改失败！`,
            key: notificationKey,
            onClick: () => {
              console.log('Notification Clicked!');
            },
          });
        }
      }
      this.editingKey = ''; // 清空 editingKey
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      if (target) {
        Object.assign(target, this.data.find(item => key === item.key));
        this.$delete(target, 'editable'); // 使用 $delete 方法删除 editable 属性
        this.data = JSON.parse(JSON.stringify(this.tempData));
      }
      this.editingKey = ''; // 清空 editingKey
    },
    async dele(key) {
      // 备份当前数据
      this.tempData = JSON.parse(JSON.stringify(this.data));

      const newData = [...this.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        // 获取要删除的数据的 ID
        const idToDelete = newData[index].id;

        try {
          // 向后端发送 DELETE 请求删除数据
          await axios.delete(`${ TRUE_URL }task/${idToDelete}`);

          // 成功删除后更新前端数据
          const deletedItem = newData.splice(index, 1)[0];
          this.data = newData;

          // 显示删除成功的提示
          const notificationKey = `delete-notification-${key}`;
          this.$notification.open({
            message: '删除成功！',
            description: `已将${this.tempData[index].headline}任务删除，单击消息撤销！`,
            icon: <a-icon type="alert" style="color: lightblue" />,
            key: notificationKey,
            onClick: async () => {
              console.log('Notification Clicked!');
              try {
                // 恢复数据时向后端发送 POST 请求
                await axios.post(`${ TRUE_URL }task/`, deletedItem);
                // 恢复前端数据
                this.data = JSON.parse(JSON.stringify(this.tempData));
              } catch (restoreError) {
                console.error('Restore error: ', restoreError);
                this.$notification.error({
                  message: '恢复失败！',
                  description: `恢复表目 ${deletedItem.headline} 失败！`,
                  onClick: () => {
                    console.log('Notification Clicked!');
                  },
                });
              }
              // 关闭提示框
              this.$notification.destroy(notificationKey);
            },
          });
        } catch (error) {
          console.error('Delete error: ', error);
          this.$notification.error({
            message: '删除失败！',
            description: `删除表目 ${this.tempData[index].headline} 失败！`,
            onClick: () => {
              console.log('Notification Clicked!');
            },
          });
        }
      }
    },

    async gene(key) {
      const newData = [...this.data];
      const index = newData.findIndex(item => key === item.key);

      if (index > -1) {
        const report = this.data[index];

        try {
          // 发送 POST 请求到后端
                      this.$notification.open({
              message: '已添加到生成队列！',
              description:
                `${report.headline}已添加到生成队列。预计生成时间：1分钟`,
              icon: <a-icon type="smile" style="color: green" />,
              onClick: () => {
                console.log('Notification Clicked!');
              },
            });
          const response = await axios.post(`${ TRUE_URL }report`, report);
          
          if (response.status === 200 || response.status === 201) {

            this.$notification.open({
              message: '已成功生成！',
              description:
                `${report.headline}已生成完毕。在数据报表➡️报告列表可以查看结果`,
              icon: <a-icon type="smile" style="color: green" />,
              onClick: () => {
                console.log('Notification Clicked!');
                this.$router.push('/page/chart/report');
              },
            });
            this.dele(key);
            newData.splice(index, 1); // 移除指定行
            this.data = newData;
          } else {
            this.$notification.error({
              message: '添加失败',
              description: `无法添加 ${report.headline} 到生成队列，请稍后重试。`,
            });
          }
        } catch (error) {
          this.$notification.error({
            message: '添加失败',
            description: `无法添加 ${report.headline} 到生成队列，请稍后重试。错误: ${error.message}`,
          });
        }
      }
    },
    async add() {
      const newData = [...this.data];
      const newKey = (Math.max(...newData.map(item => parseInt(item.id, 10))) + 1).toString();

      // 获取当前日期信息
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 补全月份
      const day = String(currentDate.getDate()).padStart(2, '0'); // 补全日期
      const formattedDate = `${year}-${month}-${day}`;

      const newEntry = {
        key: newKey,
        id: newKey,
        headline: `New Report ${newKey}`,
        date: formattedDate,  // 格式化日期为带时间部分的字符串
        position: `东经112 北纬37`,
        fix: '001',
        detector: '001',
        summary: `东经112北纬37出现了巨大裂缝`,
        tag: '严重'
      };

      try {
        // 向后端发送 POST 请求添加新数据
        await axios.post(`${ TRUE_URL }task`, newEntry);

        // 成功添加后更新前端数据
        newData.push(newEntry);
        this.data = newData;

        this.$notification.open({
          message: `已成功添加！`,
          description: `添加的表目 New Report ${newKey}，在表格尾部！`,
          icon: <a-icon type="check-circle" style="color: green" />,
          onClick: () => {
            console.log('Notification Clicked!');
          },
        });
      } catch (error) {
        console.error('Add error: ', error);
        this.$notification.error({
          message: '添加失败！',
          description: `添加表目 New Report ${newKey} 失败！`,
          icon: <a-icon type="close-circle" style="color: red" />,
          onClick: () => {
            console.log('Notification Clicked!');
          },
        });
      }
    },

    tagClick(clickedTag) {
      const newData = this.data.map(item => {
        if (item.editable == true) {
          if (item.tag === '普通') {
            item.tag = '中等';
          } else if (item.tag === '中等') {
            item.tag = '严重';
          } else {
            item.tag = '普通';
          }
        }
        return item;
      });
      this.data = newData;
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },

  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.table-container {
  background-color: white;
  padding: 20px;
}

.editable-row-operations a {
  margin-right: 8px;
}
</style>
